// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__eB4Nf","tab":"Tabs_tab__s9mKN","selected":"Tabs_selected__4qQod","tab-text":"Tabs_tab-text__lEWkR","underline":"Tabs_underline__aKCaj"};